import "./Missions.css";
import React, { useState } from "react";
import { BarLoader } from "react-spinners";
import { images } from "../../../Assets/assetsHelper";
import { Box, Typography } from "@mui/material";
import PrimaryButton from "../../../Components/Atoms/Buttons/Primary/PrimaryButton";

function Missions({ navigate, loading, missions }) {
  return (
    <div className="mainContainer">
      <div className="cont">
        <div style={{ width: "100%", textAlign: "center" }}>
          <img
            alt="Logo"
            crossOrigin={"anonymous"}
            style={{ width: "150px" }}
            src={images.Company_Logo}
          />
          <Typography
            variant={"h2"}
            sx={{
              fontSize: { xs: "18px", md: "30px" },
              margin: "0 0 10px 0",
              textAlign: "center",
            }}
          >
            Welcome to the Code Challenge Judging System! We're glad to have you
            with us. Thank you for your dedication and commitment.
          </Typography>
        </div>
        {missions && !loading ? (
          <>
            <Typography
              variant={"h3"}
              sx={{
                fontSize: { xs: "20px", md: "25px" },
                margin: "10px 0",
                textAlign: "start",
                fontWeight: "700",
              }}
            >
              Your Missions:
            </Typography>
            <Box
              sx={{
                width: "100%",
                display: "flex",
                gap: "10px",
                // flexWrap: { xs: "wrap", md: "noWrap" },
                marginTop: "20px",
                justifyContent: "space-between",
                flexWrap: "wrap",
              }}
            >
              {missions.map((mission) => (
                <>
                  <Box
                    sx={{
                      width: "fit-content",
                      backgroundColor: "white",
                      padding: { xs: "10px", md: "20px" },
                      borderRadius: "10px",
                      width: { xs: "100%", md: "24%" },
                      fontSize: "23px",
                      fontWeight: "700",
                      textAlign: "center",
                      "&:hover": {
                        boxShadow: "0px 0px 10px 0px rgba(0, 0, 0, 0.15)",
                      },
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      flexDirection: "column",
                    }}
                  >
                    <Typography
                      variant={"h5"}
                      sx={{
                        fontSize: { xs: "15px", md: "25px" },
                      }}
                    >
                      {mission?.name}
                    </Typography>
                    <Typography
                      variant={"h5"}
                      sx={{
                        fontSize: { xs: "13px", md: "20px" },
                      }}
                    >
                      <strong>Category:</strong> {mission?.category?.name}
                    </Typography>
                    <Typography
                      variant={"h5"}
                      sx={{
                        fontSize: { xs: "13px", md: "20px" },
                      }}
                    >
                      <strong>Age Group:</strong>{" "}
                      {mission?.category?.ageGroup?.name}
                    </Typography>
                    <PrimaryButton
                      classBtn={"center"}
                      text={
                        mission?.missionJudging?.completed
                          ? "Finished"
                          : mission?.judgingStatus == "started"
                          ? "see more"
                          : mission?.judgingStatus == "paused"
                          ? "paused"
                          : mission?.judgingStatus == "completed"
                          ? "completed"
                          : "not started"
                      }
                      disabled={mission?.judgingStatus != "started"}
                      style={{
                        textTransform: "capitalize",
                        borderRadius: "5px",
                        color: "var(--text-secondary)",
                        backgroundColor: "var(--primary)",
                        height: "30px",
                        padding: "0 10px",
                        minWidth: "100px",
                        textWrap: "noWrap",
                        marginTop: "10px",
                      }}
                      click={() => navigate(`/missions/${mission?.missionJudging?.id}`)}
                    />
                  </Box>
                </>
              ))}
            </Box>
          </>
        ) : (
          <div className="loadingBox">
            <BarLoader color="#6a0505" />
          </div>
        )}
      </div>
    </div>
  );
}

export default Missions;
